import React, { useState } from "react";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import MetaTags from "react-meta-tags";

export default function PusatBantuanUser() {
  const [currentDaftarPengguna, setCurrentDaftarPengguna] = useState(0);
  const [currentEditDataDiri, setCurrentEditDataDiri] = useState(0);
  const [currentOrderPengguna, setCurrentOrderPengguna] = useState(0);

  const daftarPengguna = [
    {
      text: "Unduh aplikasi UR di Play Store (Android) atau App Store (iOS) dengan kata kunci 'UR Self Order App'.",
      image: "../../asset/images/PusatBantuanUser/user-1.png",
    },
    {
      text: "Buka aplikasi UR yang sudah diunduh pada smartphone Anda.",
      image: "../../asset/images/PusatBantuanUser/user-2.png",
    },
    {
      text: "Masukkan nomor telepon yang aktif. Pastikan nomor sama dengan akun e-wallet Anda untuk mempermudah transaksi.",
      image: "../../asset/images/PusatBantuanUser/user-3.png",
    },
    {
      text: "Isi data diri lengkap pada form registrasi yang tersedia.",
      image: "../../asset/images/PusatBantuanUser/user-4.png",
    },
    {
      text: "Selamat! Akun Anda aktif dan Anda resmi menjadi pengguna UR.",
      image: "../../asset/images/PusatBantuanUser/user-5.png",
    },
  ];

  const editDataDiri = [
    {
      text: "Pada halaman utama aplikasi, pilih icon 'Profil' di pojok kanan bawah.",
      image: "../../asset/images/PusatBantuanUser/user-6.png",
    },
    {
      text: "Pilih menu 'Edit Data Diri' untuk memperbarui informasi akun Anda.",
      image: "../../asset/images/PusatBantuanUser/user-7.png",
    },
    {
      text: "Ubah data diri yang diinginkan lalu tekan tombol 'SIMPAN'.",
      image: "../../asset/images/PusatBantuanUser/user-8.png",
    },
    {
      text: "Sistem akan menampilkan konfirmasi bahwa data berhasil diperbarui.",
      image: "../../asset/images/PusatBantuanUser/user-9.png",
    },
  ];

  const orderPengguna = [
    {
      text: "Pada halaman utama, tekan tombol 'Pesan'.",
      image: "../../asset/images/PusatBantuanUser/user-10.png",
    },
    {
      text: "Beri izin akses kamera untuk memindai kode QR meja.",
      image: "../../asset/images/PusatBantuanUser/user-11.png",
    },
    {
      text: "Arahkan kamera ke kode QR meja restoran yang Anda kunjungi.",
      image: "../../asset/images/PusatBantuanUser/user-12.png",
    },
    {
      text: "Sistem akan menampilkan daftar menu lengkap restoran tersebut.",
      image: "../../asset/images/PusatBantuanUser/user-13.png",
    },
    {
      text: "Pilih menu, tentukan jumlah porsi, dan tambahkan catatan jika ada.",
      image: "../../asset/images/PusatBantuanUser/user-14.png",
    },
    {
      text: "Periksa ringkasan pesanan dan subtotal di halaman keranjang.",
      image: "../../asset/images/PusatBantuanUser/user-15.png",
    },
    {
      text: "Pilih 'Bayar' untuk melanjutkan ke metode pembayaran.",
      image: "../../asset/images/PusatBantuanUser/user-16.png",
    },
    {
      text: "Pilih metode pembayaran (QRIS, e-Wallet, atau Kasir).",
      image: "../../asset/images/PusatBantuanUser/user-17.png",
    },
    {
      text: "Konfirmasi pembayaran melalui e-Wallet Anda.",
      image: "../../asset/images/PusatBantuanUser/user-18.png",
    },
    {
      text: "Restoran menerima dan memproses pesanan Anda.",
      image: "../../asset/images/PusatBantuanUser/user-19.png",
    },
    {
      text: "Pesanan selesai dan siap dinikmati!",
      image: "../../asset/images/PusatBantuanUser/user-20.png",
    },
  ];

  const sections = [
    {
      title: "Cara Mendaftar Akun Pengguna",
      items: daftarPengguna,
      current: currentDaftarPengguna,
      setter: setCurrentDaftarPengguna,
    },
    {
      title: "Cara Mengubah Data Diri",
      items: editDataDiri,
      current: currentEditDataDiri,
      setter: setCurrentEditDataDiri,
    },
    {
      title: "Cara Memesan Makanan via QR Code",
      items: orderPengguna,
      current: currentOrderPengguna,
      setter: setCurrentOrderPengguna,
    },
  ];

  return (
    <div style={{ maxWidth: "100%", overflowX: "hidden", backgroundColor: "#ffffff" }}>
      <MetaTags>
        <title>Pusat Bantuan Pengguna | UR - Self Order App</title>
        <meta name="title" content="Pusat Bantuan Pengguna | UR" />
        <meta
          name="description"
          content="Panduan langkah demi langkah penggunaan aplikasi UR Self Order untuk pelanggan."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ur-hub.com/pusat-bantuan/user" />
      </MetaTags>

      {/* Hero */}
      <section
        style={{
          paddingTop: "130px",
          paddingBottom: "64px",
          backgroundColor: "#0f172a",
          color: "#ffffff",
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center" justify="space-between">
            <Grid item xs={12} md={7}>
              <div
                style={{
                  color: "#DE148C",
                  fontSize: "13px",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  marginBottom: "12px",
                }}
              >
                Panduan Pengguna
              </div>

              <Typography
                variant="h1"
                style={{
                  fontWeight: 800,
                  fontSize: "clamp(2rem, 4vw, 3.2rem)",
                  lineHeight: 1.2,
                  letterSpacing: "-0.02em",
                  marginBottom: "14px",
                }}
              >
                Pusat Bantuan Pengguna
              </Typography>

              <Typography
                variant="subtitle1"
                style={{
                  color: "#94a3b8",
                  fontSize: "15px",
                  lineHeight: 1.6,
                  maxWidth: "520px",
                }}
              >
                Panduan visual untuk membantu Anda menggunakan fitur aplikasi UR dengan mudah.
              </Typography>
            </Grid>

            {/* Illustration */}
            <Grid item xs={12} md={5} style={{ textAlign: "center" }}>
              <img
                src="../../asset/images/Illustration/pb_user.png"
                alt="User Help Center"
                style={{
                  maxHeight: "220px",
                  width: "auto",
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </section>

      {/* Guide Sections */}
      <section style={{ padding: "64px 0 80px 0", backgroundColor: "#f8fafc" }}>
        <Container maxWidth="lg">
          <div style={{ display: "flex", flexDirection: "column", gap: "56px" }}>
            {sections.map((sec, sIdx) => (
              <div
                key={sIdx}
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "16px",
                  padding: "36px 28px",
                  border: "1px solid #e2e8f0",
                }}
              >
                <div style={{ marginBottom: "28px" }}>
                  <Typography
                    variant="h3"
                    style={{
                      fontWeight: 700,
                      color: "#0f172a",
                      fontSize: "20px",
                      marginBottom: "6px",
                    }}
                  >
                    {sec.title}
                  </Typography>
                  <p style={{ color: "#64748b", fontSize: "14px", margin: 0 }}>
                    Pilih langkah di samping untuk melihat screenshot panduan.
                  </p>
                </div>

                <Grid container spacing={5} alignItems="center" justify="space-between">
                  {/* Left: Device Screenshot */}
                  <Grid item xs={12} md={5} style={{ textAlign: "center" }}>
                    <img
                      src={sec.items[sec.current].image}
                      alt={`Step ${sec.current + 1}`}
                      style={{
                        maxHeight: "400px",
                        maxWidth: "100%",
                        height: "auto",
                        borderRadius: "10px",
                        display: "inline-block",
                      }}
                    />
                  </Grid>

                  {/* Right: Step List */}
                  <Grid item xs={12} md={7}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                      {sec.items.map((item, idx) => {
                        const isActive = sec.current === idx;
                        return (
                          <div
                            key={idx}
                            onClick={() => sec.setter(idx)}
                            style={{
                              padding: "14px 18px",
                              borderRadius: "10px",
                              backgroundColor: isActive
                                ? "rgba(222, 20, 140, 0.06)"
                                : "#ffffff",
                              border: isActive
                                ? "1.5px solid #DE148C"
                                : "1px solid #e2e8f0",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: "14px",
                              transition: "all 0.15s ease",
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                borderRadius: "50%",
                                backgroundColor: isActive ? "#DE148C" : "#f1f5f9",
                                color: isActive ? "#ffffff" : "#64748b",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: 700,
                                fontSize: "12px",
                                flexShrink: 0,
                              }}
                            >
                              {idx + 1}
                            </div>
                            <span
                              style={{
                                color: isActive ? "#0f172a" : "#64748b",
                                fontWeight: isActive ? 600 : 500,
                                fontSize: "13px",
                                lineHeight: 1.5,
                              }}
                            >
                              {item.text}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </Grid>
                </Grid>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
